import React from "react";
import { LineChart } from '@mui/x-charts/LineChart';

function X6giorniYordini({
    data,
    titolo,
    displayTitolo
}) {


    let dataset = [];

    if (data.dataSet) {
        dataset = data.dataSet;
    }
    console.log("dataset", dataset)

    const valueFormatterImporto = (value) => (!value || value === "0.00") ? null : value.toString().replace('.', ',').replace(/\d(?=(?:(?:\d{3})+),)/g, match => `${match}.`) + " €";

    const questAnno = new Date().getFullYear()

    const keyToLabel = {
        current_year: questAnno,
        year_minus_1: questAnno - 1,
        year_minus_2: questAnno - 2,
        year_minus_3: questAnno - 3,
        year_minus_4: questAnno - 4,
        year_minus_5: questAnno - 5,
    };

    const colors = {
        current_year: 'yellow',
        year_minus_1: 'orange',
        year_minus_2: 'red',
        year_minus_3: 'lightgray',
        year_minus_4: 'gray',
        year_minus_5: 'black',
    };

    const customize = {
        height: 700,
        legend: { hidden: true },
        margin: { top: 5 }
    };

    const series = Object.keys(keyToLabel).map((key) => ({
        dataKey: key,
        label: keyToLabel[key],
        valueFormatter: (v) => valueFormatterImporto(v),
        area: false,
        connectNulls: true,
        color: colors[key],
        showMark: false
    }))

    console.log("series",series)


    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
                <div className="pa2 flex flex-wrap items-center">
                    <LineChart
                        xAxis={[{
                            dataKey: 'six_day_interval',
                            min: 1,
                            max: 53
                        }]}
                        series={series}
                        dataset={dataset}
                        {...customize}
                    />
                </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default X6giorniYordini;